import {
  IBookCategoryData,
  IBookTagData,
  IPricingData,
} from "../../apiservice/userService.type";
import { BookData, getAllBooks } from "./book-data";

export const Preferred_Category_Key = "preferredCategories";
export const Preferred_Tag_Key = "preferredTags";
export const Cache_Category_Key = "cacheCategories";
export const Cache_Tag_Key = "cacheTags";
export const Cache_Subscription_Plan_Key = "cacheSubPlan";
/**
 * Get recommended books based on user's preferred categories and tags
 * @returns Array of recommended books
 */
// export function getRecommendedBooks(): BookData[] {
//   const allBooks = getAllBooks();
//   const preferredCategories = getPreferredCategories();
//   const preferredTags = getPreferredTags();

//   // If no preferences are set, return all books
//   if (preferredCategories.length === 0 && preferredTags.length === 0) {
//     return allBooks;
//   }

//   // Filter books based on preferences
//   return allBooks.filter((book) => {
//     // Check if book matches any preferred category
//     const matchesCategory =
//       preferredCategories.length === 0 ||
//       book.categories.some((category) =>
//         preferredCategories.includes(category.id)
//       );

//     // Check if book matches any preferred tag
//     const matchesTag =
//       preferredTags.length === 0 ||
//       (book.tags && book.tags.some((tag) => preferredTags.includes(tag)));

//     // Return true if book matches either category or tag preferences
//     return matchesCategory || matchesTag;
//   });
// }

/**
 * Get user's preferred categories from localStorage
 * @returns Array of category IDs
 */
export function getPreferredCategories(): string[] {
  const savedCategories = localStorage.getItem(Preferred_Category_Key);
  return savedCategories ? JSON.parse(savedCategories) : [];
}

/**
 * Get user's preferred tags from localStorage
 * @returns Array of tag names
 */
export function getPreferredTags(): string[] {
  const savedTags = localStorage.getItem(Preferred_Tag_Key);
  return savedTags ? JSON.parse(savedTags) : [];
}

// Store Categories.
export function getCacheCategories(): IBookCategoryData[] {
  const cachedCategories = localStorage.getItem(Cache_Category_Key);
  return cachedCategories ? JSON.parse(cachedCategories) : [];
}

export function getCacheTags(): IBookTagData[] {
  const cachedTags = localStorage.getItem(Cache_Tag_Key);
  return cachedTags ? JSON.parse(cachedTags) : [];
}

//Store Subscription Plan

export function getCacheSubscriptionPlan(): IPricingData[] {
  const cachedSubPlan = localStorage.getItem(Cache_Subscription_Plan_Key);
  return cachedSubPlan ? JSON.parse(cachedSubPlan) : [];
}
